import dynamic from 'next/dynamic';

import React, { useRef, useEffect, useState } from "react";

import Navmenu from "./Navmenu";
import { menuItems } from "@/constant/data";
import Link from "next/link";
import useMobileMenu from "@/hooks/useMobileMenu";
const Icon = dynamic(() => import('@/components/ui/Icon'), { ssr: false });
import Image from "next/image";

const MobileMenu = ({ className = "custom-class" }) => {
  const [mobileMenu, setMobileMenu] = useMobileMenu();
  return (
    <div
      className={`${className} fixed  top-0 bg-white dark:bg-metaxseed-black shadow-lg  h-full   w-[248px] overflow-y-auto`}
    >
      <div className="logo-segment flex justify-between items-center bg-white dark:bg-metaxseed-black z-[9] h-[72px] px-6 ">
        <Link href="/">
          <div className="flex items-center">
            <div className="logo-icon">
              <Image
                src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                className="h-8 w-8"
                height={411}
                width={370}
                alt=""
              />
            </div>
          </div>
        </Link>
        <button
          type="button"
          onClick={() => setMobileMenu(!mobileMenu)}
          className="cursor-pointer text-zinc-900 dark:text-white text-2xl"
        >
          <Icon icon="heroicons:x-mark" />
        </button>
      </div>

      <div
        className="sidebar-menu px-4 h-[calc(100%-80px)]"
      >
        <Navmenu menus={menuItems} />
      </div>
    </div>
  );
};

export default MobileMenu;
